export const AZUBI_JOB = 'ausbildungsberuf'
export const AZUBI_MARKET = 'markt'
export const AZUBI_START = 'ausbildungsstart'
export const AZUBI_YEAR = 'ausbildungsJahr'
export const AZUBI_NACHWEIS = 'ausbildungsnachweisTyp'
export const AZUBI_NAME = 'name'
export const AZUBI_ABTEILUNG = 'abteilung'

export const GLOBAL_FILTERS = [AZUBI_JOB, AZUBI_MARKET, AZUBI_YEAR]
